/**
 * We use Material UI breakpoints,
 * check out link for details: https://mui.com/material-ui/customization/breakpoints/#default-breakpoints
 */
export const breakpoints = <const>['xs', 'sm', 'md', 'lg', 'xl'];
